export enum EnumIndIEDest {
    CONTRIBUINTE_ICMS = 1,
    ISENTO = 2,
    NAO_CONTRIBUINTE = 9
}